import { createRecordType } from "@supersig/store";
import { T } from "@supersig/validate";
import { nanoid } from "nanoid";
import { idValidator } from "../misc/id-validator";
import { localizationProviderIdValidator } from "../localizationProviders";
export const PresentationStyles = [
    "FULLSCREEN",
    "MODAL",
    "PUSH",
    "NO_ANIMATION",
    "DRAWER"
];
export const PresentationConditions = [
    "CHECK_USER_SUBSCRIPTION",
    "ALWAYS"
];
export const FeatureGatingValues = [
    "GATED",
    "NON_GATED"
];
export const ReRouteBackButtonValues = [
    "ENABLED",
    "DISABLED"
];
export const IsScrollEnabledValues = [
    "ENABLED",
    "DISABLED"
];
export const GameControllerSupportValues = [
    "ENABLED",
    "DISABLED"
];
export const OnDeviceCacheValues = [
    "ENABLED",
    "DISABLED"
];
export const TemplateTypeValues = [
    "GLOBAL",
    "UNLISTED"
]// Can in theory be "ORGANIZATION" as well
;
export const PaywallValidator = T.model("paywall", T.object({
    id: idValidator("paywall"),
    typeName: T.literal("paywall"),
    version: T.number,
    name: T.string.optional(),
    identifier: T.string.optional(),
    presentationCondition: T.literalEnum(...PresentationConditions),
    presentationStyle: T.literalEnum(...PresentationStyles),
    reRouteBackButton: T.literalEnum(...ReRouteBackButtonValues).optional(),
    gameControllerSupport: T.literalEnum(...GameControllerSupportValues).optional(),
    featureGating: T.literalEnum(...FeatureGatingValues),
    onDeviceCache: T.literalEnum(...OnDeviceCacheValues),
    isScrollEnabled: T.literalEnum(...IsScrollEnabledValues).optional(),
    editable: T.boolean,
    templateType: T.literalEnum(...TemplateTypeValues).optional(),
    templateId: T.string.optional(),
    localizationProvider: T.object({
        id: localizationProviderIdValidator,
        internalLocalizationProviderId: T.number,
        projectDisplayName: T.string
    }).optional()
}));
export const SWPaywallRecordType = createRecordType("paywall", {
    validator: PaywallValidator,
    scope: "document"
}).withDefaultProperties(()=>({
        name: "New Paywall - " + new Date().toLocaleDateString(),
        presentationCondition: "CHECK_USER_SUBSCRIPTION",
        presentationStyle: "FULLSCREEN",
        reRouteBackButton: "DISABLED",
        gameControllerSupport: "DISABLED",
        featureGating: "NON_GATED",
        onDeviceCache: "ENABLED",
        isScrollEnabled: "ENABLED"
    }));
export function isPaywall(record) {
    if (!record) return false;
    return record.typeName === "paywall";
}
export function isPaywallId(id) {
    if (!id) return false;
    return id.startsWith("paywall:");
}
/** @public */ export function createPaywallId(id) {
    return `paywall:${id !== null && id !== void 0 ? id : nanoid()}`;
}
export const paywallId = createPaywallId("paywall");
